<template>
  <div>
    <v-toolbar color="primary">
      <v-toolbar-title class="ml-0 pl-3 white--text" style>
        <strong><span style="font-size:1.2rem;">Select Staying Days</span></strong>
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="ma-2 px-5" white>
      <v-card-text class="pb-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-form class="pt-2" lazy-validation ref="formRef" row wrap>
              <v-layout row wrap class="px-2">
                <header-text :text="$vuetify.lang.t('$vuetify.visa_option')"
                             icon="mdi-equal-box"/>
                <v-flex xs12>

                  <div v-if="passport_valid_date">
                    <v-alert
                        class="mb-6"
                        outlined
                        type="warning"
                        color="orange"
                    >
                      Cannot apply for this condition. Invalid passport validity
                    </v-alert>
                  </div>
                  <div :key="condition.id" v-for="condition in conditions">
                    <v-alert
                        class="mb-6"
                        outlined
                        type="info"
                        v-if="condition.message">
                      {{ condition.message }}
                    </v-alert>
                  </div>
                  <div v-if="existingVisa">
                    <v-alert
                        class="mb-6"
                        outlined
                        type="info"
                    >
                      {{ $vuetify.lang.t('$vuetify.existing_visa') }}
                    </v-alert>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-alert
                      class="mb-6"
                      type="info"
                      outlined
                      v-if="visa.condition">

                    Your visa cost is <strong>USD($) {{ cost }}</strong>
                  </v-alert>
                  <v-alert
                      class="mb-4"
                      type="info"
                      v-if="limited_day_visa"
                  >
                    You will get visa for only {{ remaining_days }} days
                  </v-alert>
                  <v-alert
                      class="mb-4"
                      type="error"
                      v-if="overstayed"
                  >
                    Cannot process your visa. You have overstayed . Please contact immigration
                    office for further query
                  </v-alert
                  >
                  <v-alert
                      class="mb-4"
                      type="error"
                      v-if="similar_overstayed"
                  >
                    Cannot process your visa. Person with same name , country and date of birth
                    exists. Please contact immigration office for further query
                  </v-alert>
                  <v-alert
                      class="mb-4"
                      type="info"
                      v-if="selected_country.blacklisted"
                      outlined
                  >
                    Recommendation letter for prohibited countries is compulsory.
                  </v-alert>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-select
                      :items="conditions"
                      :label="$vuetify.lang.t('$vuetify.visa_option')+' *'"
                      :rules="[rules.required]"
                      item-text="name"
                      :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                      item-value="id"
                      outlined
                      v-model="visa.condition"
                      id="visaCondition"
                      @change="conditionSelected"
                  />
                </v-flex>

                <v-flex v-if="visa_type.slug === tourist_visa_slug && apply_type!=='entry'" xs12 sm6>
                  <v-combobox
                      :items="purpose_of_visa"
                      :label="$vuetify.lang.t('$vuetify.purpose_of_visa')+' *'"
                      :rules="[rules.required]"
                      outlined
                      value="Tourist Entry Visa"
                      item-text="name"
                      item-value="name"
                      v-model="visa.purpose"
                      id="visaPurpose"
                  />
                </v-flex>
                <v-flex xs12 md4 v-if="apply_type==='arrival'">
                  <v-autocomplete
                      :items="airports"
                      :label="$vuetify.lang.t('$vuetify.arrival_airport')+' *'"
                      :rules="[rules.required]"
                      :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                      item-value="id"
                      item-text="name"
                      outlined
                      v-model="visa.arrival_airport"
                      id="arrivalAirport"
                  />
                </v-flex>
                <v-flex v-if="apply_type==='arrival'" xs12 md4>
                  <v-autocomplete
                      :items="countries"
                      item-value="id"
                      :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                      item-text="country_name"
                      :label="$vuetify.lang.t('$vuetify.last_arriving_country')+' *'"
                      :rules="[rules.required]"
                      outlined
                      v-model="visa.last_arriving_country"
                      id="lastArrivalCountry"
                  />
                </v-flex>

                <v-flex xs12 md4 v-if="apply_type === 'arrival'">
                  <v-text-field
                      :label="$vuetify.lang.t('$vuetify.transport_no')+ ' *'"
                      :rules="[rules.required]"
                      outlined
                      type="text"
                      v-model="visa.extra.transport_no"
                  />
                </v-flex>

                <v-flex xs12>
                  <component v-bind:is="visa_type.slug"/>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="px-2" v-if="apply_type !== 'eta'">
                <header-text
                    v-if="visa_type.slug === tourist_visa_slug"
                    :text="$vuetify.lang.t('$vuetify.check_if_applicable')"
                    icon="mdi-equal-box"
                />
                <v-flex v-if="apply_type === 'arrival' " xs12></v-flex>
                <v-flex xs12 md4 v-if="visa_type.slug === tourist_visa_slug">
                  <v-checkbox
                      :label="$vuetify.lang.t('$vuetify.has_recommendation_letter')"
                      :value="1"
                      outlined
                      v-model="visa.has_recommendation_letter"
                      id="recommendation_letter"
                  />
                </v-flex>
                <v-flex xs12 md4 v-if="visa_type.slug === tourist_visa_slug && apply_type!=='entry'">
                  <v-checkbox
                      :label="$vuetify.lang.t('$vuetify.i_am_nrn')"
                      :value="1"
                      outlined
                      v-model="visa.i_am_nrn"
                      id="nrn_letter"
                  />
                </v-flex>
                <v-flex xs12 md4 v-if="selected_country.blacklisted">
                  <v-checkbox
                      label="I have recommendation letter"
                      :value="1"
                      outlined
                      v-model="recommendation_letter"
                      id="recommendation"
                  />
                </v-flex>

                <v-flex sm4 xs12 v-if="visa_type.slug === tourist_visa_slug">
                  <v-checkbox
                      :label="$vuetify.lang.t('$vuetify.accompanied_by')"
                      :value="1"
                      outlined
                      v-model="visa.accompanied_by"
                      id="accompanied"
                  />
                </v-flex>

                <v-flex xs4 v-if="visa.i_am_nrn === 1">
                  <v-text-field
                      :label="$vuetify.lang.t('$vuetify.nrn_number')+' *'"
                      :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                      :rules="[rules.required]"
                      outlined
                      type="text"
                      v-model="visa.nrn_number"
                      id="nrnNumber"
                  />
                </v-flex>

                <v-flex md4 sm12 v-if="visa.accompanied_by === 1" xs12>
                  <v-text-field
                      :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                      :label="$vuetify.lang.t('$vuetify.full_name')+' *'"
                      :rules="[rules.required]"
                      outlined
                      type="text"
                      v-model="visa.accompanied_name"
                      id="accompaniedName"
                  />
                </v-flex>
                <v-flex md4 sm12 v-if="visa.accompanied_by === 1" xs12>
                  <v-text-field
                      :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                      :label="$vuetify.lang.t('$vuetify.passport_number')+' *'"
                      :rules="[rules.required]"
                      outlined
                      type="text"
                      v-model="visa.accompanied_passport_number"
                      id="accompaniedPassportNo"
                  />
                </v-flex>
                <v-flex md4 sm12 v-if="visa.accompanied_by === 1" xs12>
                  <v-autocomplete
                      :items="relations"
                      :label="$vuetify.lang.t('$vuetify.relation')+' *'"
                      :rules="[rules.required]"
                      outlined
                      item-text="name"
                      item-value="name"
                      v-model="visa.accompanied_relation"
                      id="accompaniedRelation"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>

        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-flex class="mb-2" md12 xs12>
          <v-btn
              @click="proceed"
              class="float-right"
              color="blue darken-3"
              dark
              large
              v-if="!existingVisa"
              :disabled="passport_valid_date || !recommendation_letter"
              :loading="loading"
          >{{ $vuetify.lang.t('$vuetify.proceed') }}
          </v-btn>
          <v-btn
              @click="goBack"
              class="float-right mr-2"
              color="red darken-3"
              dark
              large
          >{{ $vuetify.lang.t('$vuetify.back') }}
          </v-btn>
        </v-flex>
      </v-card-actions>

    </v-card>
  </div>
</template>

<script>
import ToolBar from "../../components/ToolBar";
import {mapActions, mapGetters} from 'vuex';
import {validationMixin} from "../../mixins/validationMixin";
import TouristVisa from "../../components/visa/form/TouristVisa";
import TransitVisa from "../../components/visa/form/TransitVisa";
import DiplomaticVisa from "../../components/visa/form/DiplomaticVisa";
import HeaderText from "../../components/HeaderText";
import {tourist_visa_slug, transit_visa_slug} from "../../constant/appConstant";
import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
import FileInput from "../../components/FileInput";
import {fetchDynamicValues} from "../../helpers/dynamicValueHelper";
import moment from 'moment';

export default {
  name: "SelectVisa",
  data: () => ({
    relation: [],
    tourist_visa_slug, transit_visa_slug,
    overstayed: false,
    similar_overstayed: false,
    purpose_of_visa: [],
    passport_valid_date: false,
    recommendation_letter: true,
    loading: false,
  }),
  components: {
    ToolBar, TouristVisa, TransitVisa, FormErrorDisplayHandler, HeaderText, FileInput, DiplomaticVisa
  },
  mixins: [validationMixin],
  beforeRouteEnter(to, from, next) {

    if (!from.name) {
      next(vm => {
        let apply_type = vm.$route.params.apply;
        let office = vm.$route.params.office;
        if (apply_type === 'arrival') {
          if (office === 'doi') {
            vm.$router.push({
              name: 'EntryVisaProcessing'
            })
            return
          }
          vm.$router.push({
            name: 'OnArrival',
            params: {office}
          })
        } else {
          vm.$router.push({
            name: 'OnlineApplication'
          })
        }

      })
    }
    next();
  },
  computed: {
    ...mapGetters('VisaType', ['conditions', 'visa_type', 'remaining_days']),
    ...mapGetters('VisaSingle', ['purposeAutoCompletes', 'office', 'apply_type', 'existingVisa']),
    cost() {
      console.log()
      let condition = this.conditions.find(i => i.id === this.visa.condition);
      if (this.visa.has_recommendation_letter || this.visa.i_am_nrn) {
        return 0;
      }
      if (condition) {
        return condition.cost;
      }
      return null;
    },
    visa() {
      return this.$store.state.VisaSingle.visa;
    },
    airports() {
      return this.$store.state.AirPort.airports;
    },
    countries() {
      return this.$store.state.CountryForTouristList.all;
    },
    selected_country() {
      return this.countries.find((c) => c.id === this.visa.traveller.country);
    },
    limited_day_visa() {

      let condition = this.conditions.find(i => i.id === this.visa.condition);

      if (condition)
        return this.remaining_days < parseInt(condition.days);

      return false;
    },

  },
  methods: {
    ...mapActions('VisaSingle', ['checkVisaStatus']),
    proceed() {
      if (this.$refs.formRef.validate()) {
        this.visa.extra.application_data.traveller = this.visa.traveller;
        let selected_condition = this.conditions.find((i) => i.id === this.visa.condition);
        if (this.visa_type.slug === 'transit-visa') {
          this.visa.purpose = "Transit";
          let last_arriving_country = this.countries.find((i) => this.visa.last_arriving_country === i.id);
          if (last_arriving_country.country_name === this.visa.extra.application_data.next_destination_country) {
            this.$store.commit('Notification/showError', 'Last arriving country and next travelling country cannot be same');
            return;
          }
        }
        this.$store.commit('VisaType/setSelectedCondition', selected_condition);
        let days = selected_condition.days;
        if (this.limited_day_visa) {
          days = this.remaining_days;
        }
        this.$store.commit('VisaSingle/setPrice', {
          cost: this.cost.toString(),
          days
        });
        this.loading = true;
        this.checkVisaStatus().then((data) => {
          this.loading = false;
          this.overstayed = data.overstayed;
          this.similar_overstayed = data.similar_over_stayed;
          if (!data.overstayed && !data.similar_over_stayed) {
            this.$router.push({
              name: 'ConfirmApplication',
              params: {
                apply: this.apply_type,
                office: this.office
              }
            })
          }
        })
      } else {
        this.loading = false;
        this.$store.commit('Notification/showError', 'Invalid form data')
      }
    },
    goBack() {
      this.$router.go(-1);
      // this.$router.push({
      //     name: 'VisaApplication'
      // })
    },
    conditionSelected() {
      this.passport_valid_date = false;
      let selected_condition = this.conditions.find((i) => i.id === this.visa.condition);
      let days = parseInt(selected_condition.days);
      let a = moment().format();
      let b = moment(this.visa.passport.validity, 'YYYY-MM-DD');
      let diffDays = b.diff(a, 'days');
      if (diffDays < days) {
        this.passport_valid_date = true;
      }
    }
  },
  mounted() {
    this.$store.dispatch('fetchAirports');
    fetchDynamicValues('Relations').then((data) => {
      this.relations = data;
    });
    fetchDynamicValues('PurposeOfVisa').then((data) => {
      this.purpose_of_visa = data;
    });

    if (this.selected_country.blacklisted)
      this.recommendation_letter = false;
  }
}
</script>

